export default __webpack_public_path__ + "static/media/SEMILLAMAIZ_EN.804b06af.jpg";